/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { Item } from "../models";
import { getOverrideProps, useDataStoreBinding } from "./utils";
import ListedItem from "./ListedItem";
import { Collection } from "@aws-amplify/ui-react";
export default function ListedItemCollection(props) {
  const { items: itemsProp, overrideItems, overrides, ...rest } = props;
  const [items, setItems] = React.useState(undefined);
  const itemsDataStore = useDataStoreBinding({
    type: "collection",
    model: Item,
  }).items;
  React.useEffect(() => {
    if (itemsProp !== undefined) {
      setItems(itemsProp);
      return;
    }
    async function setItemsFromDataStore() {
      var loaded = await Promise.all(
        itemsDataStore.map(async (item) => ({
          ...item,
          receipt: await item.receipt,
          itemAds: await item.itemAds.toArray(),
        }))
      );
      setItems(loaded);
    }
    setItemsFromDataStore();
  }, [itemsProp, itemsDataStore]);
  return (
    <Collection
      type="list"
      isSearchable="true"
      isPaginated={true}
      searchPlaceholder="Rehercher ..."
      itemsPerPage={50}
      direction="column"
      justifyContent="left"
      items={items || []}
      {...getOverrideProps(overrides, "ListedItemCollection")}
      {...rest}
    >
      {(item, index) => (
        <ListedItem
          item={item}
          key={item.id}
          {...(overrideItems && overrideItems({ item, index }))}
        ></ListedItem>
      )}
    </Collection>
  );
}
